export default "__VITE_ASSET__1c31dbd8__"